import "./search.scss";
import { useEffect, useState } from "react";
import { BsArrowLeftCircle } from "react-icons/bs";
import { sendRequestAPIMain } from "hooks/useAxios";
import { NavLink } from "react-router-dom";
import { useDetectClickOutside } from "react-detect-click-outside";

import styles from "../home.module.css";
import { BsSearch } from "react-icons/bs";

export default function Search() {
  const clearSearchValue = () => {
    setsSearchValue("");
  };
  const ref = useDetectClickOutside({ onTriggered: clearSearchValue });

  const [searchValue, setsSearchValue] = useState("");
  const [searchResult, setSearchResult] = useState("");

  useEffect(() => {
    if (searchValue !== "") {
      sendRequestAPIMain("search_keyword", { keyword: searchValue }).then(
        ({ data }) => {
          setSearchResult(data);
        }
      );
    } else {
      setSearchResult([]);
    }
  }, [searchValue]);

  return (
    <div className="search-container mx-5" style={{ width: "65%" }}>
      <div className={styles.filter} ref={ref}>
        <button className={styles.btnShowCase}>
          <BsSearch />
        </button>
        <input
          type="text"
          placeholder="ارز مورد نظر خود را جستجو کنید... "
          className={styles.filterSelect}
          value={searchValue}
          onChange={(e) => {
            setsSearchValue(e.target.value);
          }}
        />
      </div>

      {searchResult.length != 0 && (
        <div className="search-result-container">
          <SearchResultItemContainer
            title={"ارز ها: "}
            type="coins"
            searchResult={searchResult}
          />
          <SearchResultItemContainer
            title={"صرافی ها: "}
            type="exchange"
            searchResult={searchResult}
          />
        </div>
      )}
    </div>
  );
}
function SearchResultItemContainer({ title, searchResult, type }) {
  const showResultBaseOnType = () => {
    let temp;
    switch (type) {
      case "coins":
        temp = searchResult.cc?.map((value) => (
          <NavLink to={`/currency/${value}`} style={{ textDecoration: "none" }}>
            <div className="value-container">
              <div className="title">
                ارز
                <span className="value"> {value} </span>
              </div>
            </div>
          </NavLink>
        ));

        return temp.length !== 0 ? temp : <small>نتیجه ای یافت نشد!</small>;
      case "exchange":
        temp = searchResult.exchange?.map((value) => (
          <NavLink to={`/exchange/${value}`} style={{ textDecoration: "none" }}>
            <div className="value-container">
              <div className="title">
                صرافی
                <span className="value"> {value} </span>
              </div>
            </div>
          </NavLink>
        ));

        return temp.length !== 0 ? temp : <small>نتیجه ای یافت نشد!</small>;
      default:
        break;
    }
  };
  return (
    <>
      <div>
        <div className="search-result-item-container">
          <div className="header ">
            <div className="title-section" style={{ paddingRight: "3px" }}>
              {title}
            </div>
            {/* <div className="left-arrow">
              <BsArrowLeftCircle></BsArrowLeftCircle>
            </div> */}
          </div>

          <span className="search-value">{showResultBaseOnType()}</span>
        </div>
      </div>
    </>
  );
}
